import Mustache from "mustache";
/* eslint-disable */

/**
 * Get card html
 */
const cardHTML = (location) => {
    if (!location) return false;
    const $id = location.ID;

    location.location_title = location.location_title.startsWith("Industrious ") ? location.location_title.substring("Industrious ".length) : location.location_title;

    let contentString = [
        `<div id="location_${$id}" class="d-none row no-gutters border border-radius-sm location-marker-til mb-2 mb-md-3" data-marker-id="${$id}" data-test-id="perimeter_card_1" style="position: relative;">
        {{#show_special_offer_tag}}<span class="btn-squared-tag btn-squared-tag-xs label-tag ab-testing-label-color" style="background:{{color_promo_banner}}; color:{{color_text_promo_banner}};">${window.js_translate.special_offer}</span>{{/show_special_offer_tag}}
        <div class="col-12 col-md-6">
            <div id="swiper_${$id}" class="swiper-container swiper-container--arrow-small swiper-container--white-arrow-fill marker-market-carousel-wrapper" style="cursor: grab;">
              <div class="swiper-wrapper h-100 embed" style="transform: translate3d(0px, 0px, 0px);">
                {{#carousel_first_item}}
                <div class="swiper-slide imageWrapper">
                  <a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="Perimeter" data-section="spot-1" aria-label="Go to Perimeter"></a>
                  <img class="js-lazy-load-image map-lazy-load-images stretch-image" alt="{{title}}" data-src="{{carousel_first_item}}" data-was-processed="true">
                </div>
                {{/carousel_first_item}}
              </div>
              <div class='swiper-pagination swiper-pagination-clickable swiper-pagination-bullets'><span class='swiper-pagination-bullet swiper-pagination-bullet-active'></span><span class='swiper-pagination-bullet'></span><span class='swiper-pagination-bullet'></span><span class='swiper-pagination-bullet'></span></div>
              <div class='swiper-button swiper-button-next swiper-button-disabled'><span class='icon arrow icon-hex-arrow-right' data-arrow='right arrow' tabindex='-1'></span></div><div class='swiper-button swiper-button-prev swiper-button-disabled'><span class='icon arrow icon-hex-arrow-left' data-arrow='left arrow' tabindex='-1'></span></div>
            </div>
          </div>
          <div class="col-12 col-md-6">
            <a class="link-to-all gtm-view-details" href="{{permalink}}" data-location="{{location_title}}" data-section="spot-1" aria-label="Go to {{location_title}}"></a>
            <div class="til-content market-location-content p-2">
              <div class="content-wrapper">
                {{#show_tag}}<span class="btn-squared-tag btn-squared-tag-sm">{{text_status}}</span>{{/show_tag}}
                <h2 class="til-title locationTitle">{{location_title}}</h2>
                
                {{#inter_address}}
                <div class="address">${location.inter_address ? location.inter_address.replaceAll("\\n", "<br/>") : false}</div>
                {{/inter_address}}

                {{^inter_address}}
                  {{#address}} 
                  <div class="address">{{address}}</div>
                  {{/address}} 
                  <div class="address">{{#city}} {{city}} ,{{/city}} {{#abbr}}{{abbr}}{{/abbr}} {{#zip}}{{zip}}{{/zip}}</div>
                {{/inter_address}}
                
                {{#show_phone}}
                <div class="phone-wrapper"><a href="tel:{{phone}}" class="phone">{{phone}}</a></div>
                {{/show_phone}}
              </div>
              <div class="market-location-action">
                <div class="see-location ml-auto"><span class="btn-link tertiary-text-color link-underline gtm-view-details" aria-label="see location" data-location="{{location_title}}">${window.js_translate.learn_more}</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
     `,
    ].join("\n");

    const cardHTML = Mustache.render(contentString, location);

    return cardHTML;
};

export default cardHTML;
